import { render, staticRenderFns } from "./FeaturesDrawer.vue?vue&type=template&id=f871e346&lang=pug"
import script from "./FeaturesDrawer.vue?vue&type=script&lang=coffee"
export * from "./FeaturesDrawer.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports